<template>
  <v-container fluid class="pa-0 mo-bg" style="min-height: 87vh">
    <v-row class="ma-0 pa-0" align="center" justify="center">
      <v-col cols="12" sm="10" md="8" lg="7">
        <v-sheet
          class="mo-panel neo-surface elevation-3 rounded-xl mx-auto"
          max-width="820"
        >
          <v-toolbar flat dense class="mo-toolbar">
            <v-btn icon small class="white--text mr-1" @click="goBack">
              <v-icon color="white" small>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text d-flex align-center">
              <v-icon left color="white" class="mr-2">mdi-factory</v-icon>
              DETAIL FORM PALLET
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              small
              class="white--text"
              :disabled="loading"
              @click="refreshData"
            >
              <v-icon color="white" small :class="{ spin: loading }"
                >mdi-refresh</v-icon
              >
            </v-btn>
          </v-toolbar>
          <div class="position-relative">
            <canvas ref="bgCanvas" class="bg-canvas"></canvas>
            <div class="pa-6 neo-surface">
              <v-skeleton-loader v-if="loading" type="article, actions" />
              <div v-else>
                <v-row dense>
                  <v-col cols="12">
                    <div class="mo-header value emphasis-1">
                      {{ data.company }}
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">NO PALET</div>
                    <div class="value strong">{{ data.no_palet }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">NO LOT</div>
                    <div class="value strong">{{ data.no_lot }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">NO SO</div>
                    <div class="value">{{ data.no_so }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">NO MEMO</div>
                    <div class="value">{{ data.no_memo }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">KODE PRODUK</div>
                    <div class="value">{{ data.kode_produk }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">NAMA PRODUK</div>
                    <div class="value uppercase">{{ data.nama_produk }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">TGL PRODUKSI</div>
                    <div class="value">{{ data.tgl_produksi }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">TGL ORDER</div>
                    <div class="value">{{ data.tgl_order }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">SHIFT</div>
                    <div class="value">{{ data.shift }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">MESIN</div>
                    <div class="value uppercase">{{ data.mesin }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">JUMLAH MUATAN</div>
                    <div class="value">{{ data.jumlah_muatan }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">JUMLAH LOADING</div>
                    <div class="value">
                      <v-text-field
                        class="neo-input"
                        label="Masukkan jumlah"
                        type="number"
                        min="0"
                        v-model.number="data.inputQty"
                        dense
                        outlined
                      />
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">SISA MUATAN</div>
                    <div class="value">{{ data.sisa_muatan }} DUS</div>
                  </v-col>
                </v-row>
                <v-row dense class="mt-5">
                  <v-col cols="12">
                    <v-btn block class="neo-btn" @click="saveQty">SIMPAN</v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn block class="neo-btn mt-2" @click="goBack">
                      BATAL</v-btn
                    >
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- Notif sukses simpan -->
    <v-dialog v-model="dialogSaved" max-width="420">
      <v-card class="neo-surface pa-5 text-center">
        <v-icon color="#43A047" large>mdi-check-circle</v-icon>
        <div class="mt-2 strong">Data berhasil disimpan.</div>
        <div class="mt-3">
          <v-btn class="neo-btn" @click="onSavedOk">OK</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Notif warning -->
    <v-dialog v-model="dialogWarning" max-width="380">
      <v-card class="neo-surface pa-5 text-center">
        <v-icon class="warning-icon" large>mdi-alert-circle</v-icon>
        <div class="mt-3 strong">
          {{ warningMessage || 'Jumlah muatan minimal 1.' }}
        </div>
        <div class="mt-4">
          <v-btn class="neo-btn" @click="dialogWarning = false">MENGERTI</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Notif selesai -->
    <v-dialog v-model="dialogFinish" max-width="420">
      <v-card class="neo-surface pa-5 text-center">
        <v-icon color="#43A047" large>mdi-check-circle</v-icon>
        <div class="mt-2 strong">
          Silahkan ambil form palet yang telah berhasil dicetak
        </div>
        <div class="mt-3">
          <v-btn class="neo-btn" @click="finishFlow">SELESAI</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: 'PalletDetail',
  data() {
    return {
      loading: true,
      data: {
        company: 'PT INDOMULTI MAS PERKASA',
        no_palet: '',
        no_lot: 'LOT-250915-01',
        no_so: 'SO-2509-00088',
        no_memo: '20250900056',
        tgl_order: '30/09/2025 07:38',
        kode_produk: 'SKU-24-ABC',
        nama_produk: 'AMDK 330ml SQA',
        tgl_produksi: '09/07/2025 06:00',
        shift: 'SHIFT 1',
        mesin: 'MESIN KRONES BOTOL',
        jumlah_muatan: 84,
        inputQty: 0,
        sisa_muatan: 0
      },
      inputIndex: -1,
      inputQty: null,
      dialogSaved: false,
      dialogWarning: false,
      warningMessage: '',
      dialogFinish: false
    }
  },
  methods: {
    goBack() {
      this.$router && this.$router.back()
    },
    onSavedOk() {
      this.dialogSaved = false
      // Return to pallet detail page
      if (this.$router) this.$router.back()
    },
    saveQty() {
      const v = Number(this.data.inputQty)
      if (!v || isNaN(v) || v < 1) {
        this.warningMessage = 'Masukkan jumlah loading minimal 1.'
        this.dialogWarning = true
        return
      }
      if (this.inputIndex >= 0) {
        // existing update logic â€¦
      }
      this.dialogSaved = true
    },
    finishFlow() {
      this.dialogFinish = false
      this.$router && this.$router.push({ name: 'lotChecker' })
    },
    drawBackground() {
      const canvas = this.$refs.bgCanvas
      if (!canvas) return
      const w = canvas.parentElement.clientWidth
      const h = 220
      canvas.width = w
      canvas.height = h
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, w, h)
      const g1 = ctx.createRadialGradient(
        w * 0.25,
        h * 0.5,
        10,
        w * 0.25,
        h * 0.5,
        170
      )
      g1.addColorStop(0, 'rgba(144,202,249,.35)')
      g1.addColorStop(1, 'rgba(144,202,249,0)')
      ctx.fillStyle = g1
      ctx.beginPath()
      ctx.arc(w * 0.25, h * 0.55, 150, 0, Math.PI * 2)
      ctx.fill()
      const g2 = ctx.createRadialGradient(
        w * 0.8,
        h * 0.2,
        10,
        w * 0.8,
        h * 0.2,
        150
      )
      g2.addColorStop(0, 'rgba(165,214,167,.35)')
      g2.addColorStop(1, 'rgba(165,214,167,0)')
      ctx.fillStyle = g2
      ctx.beginPath()
      ctx.arc(w * 0.8, h * 0.25, 140, 0, Math.PI * 2)
      ctx.fill()
    },
    refreshData() {}
  },
  mounted() {
    this.$nextTick(() => this.drawBackground())
    window.addEventListener('resize', this.drawBackground)
    const no = (this.$route && this.$route.query && this.$route.query.no) || ''
    this.data.no_palet = no
    setTimeout(() => {
      this.loading = false
    }, 650)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawBackground)
  }
}
</script>

<style scoped>
.mo-header {
  text-align: center;
  position: relative;
  min-height: 28px;
  padding-top: 2px;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
  color: #37474f;
}
.mo-toolbar {
  background: linear-gradient(135deg, #90caf9 0%, #a5d6a7 100%);
}
.mo-bg {
  background: linear-gradient(180deg, #fafcff 0%, #ffffff 70%);
}
.mo-panel {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}
.bg-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 220px;
  pointer-events: none;
}
.neo-surface {
  --bg: #f3f6fb;
  background: var(--bg) !important;
}
.label {
  color: #6b7280;
  font-size: 0.85rem;
  margin-bottom: 2px;
}
.value {
  color: #263238;
}
.center {
  text-align: center;
}
.value.uppercase {
  text-transform: uppercase;
}
.value.strong {
  font-weight: 700;
}
.value.emphasis-1 {
  font-size: 1.25rem;
  font-weight: 700;
}
.value.emphasis-2 {
  font-size: 1.15rem;
  font-weight: 600;
}
.neo-btn.v-btn {
  --bg: #f3f6fb;
  --hi: rgba(255, 255, 255, 0.95);
  background: var(--bg) !important;
  color: #263238 !important;
  border-radius: 14px !important;
  padding: 10px 16px !important;
  text-transform: none;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.08), -8px -8px 16px var(--hi) !important;
}
.neo-btn.v-btn::before {
  background-color: transparent !important;
}
</style>
